import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { authService } from '../apis/AuthService';
import '../../css/pages/login.css';
import Loading from '../components/Loading';
import NavigationLayout from '../components/Layouts/NavigationLayout';

class Login extends Component {
  state = {
    login: true,
    loading: false,
    redirectToReferrer: false
  };
  code = sessionStorage.getItem('code');

  signIn = async code => {
    this.setState({
      loading: true
    });
    if (code) {
      this.code = null;
      sessionStorage.removeItem('code');
      try {
        await authService.authenticate(code);
        console.log('Successfuly signed-in.');
        this.setState({
          login: false,
          loading: false,
          redirectToReferrer: true
        });
      } catch (err) {
        console.log('Unauthorized');
        this.setState({
          loading: false
        });
      }
    }
  };

  componentDidMount = () => {
    this.setState({
      redirectToReferrer: false
    });
  };

  handleLogin = () => {
    window.location.replace(window._PREO_DATA._REACT_APP_WEBAPP_BASE_URL);
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { redirectToReferrer, loading, login } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }

    if (loading) {
      return <Loading delay="0" />;
    }

    if (this.code) {
      this.signIn(this.code);
      return <Loading delay="0" />;
    }

    return (
      <NavigationLayout>
        <div style={{ height: '92%' }}>
          <Dialog
            open={login}
            onClose={this.handleLogin}
            aria-labelledby="alert-dialog-slide-title"
          >
            <DialogTitle id="alert-dialog-slide-title">
              Session expired
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Your session has expired. Please login again.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleLogin}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </NavigationLayout>
    );
  }
}

export default Login;
